module.exports = __webpack_public_path__ + "static/media/arrow-right-white.e36e99cd.svg";